export const unparseString = (newValue: string | any): any => {
    try {
        let value;
        // console.log('[TRAZA] unparseString entry! ', newValue)
        if (newValue === 'undefined') newValue = undefined;
        if (newValue === 'null') newValue = null;
        if (newValue === '{}') newValue = {};
        if (typeof newValue === 'string') {
            newValue = newValue.replace(/'/g, '\"');
            value = JSON.parse(newValue);
        }
        else {
            value = newValue;
        }
        // console.log('[TRAZA] object unparsed! ', value)
        return value;
    } catch (error) {
        return newValue;
    }

}
export const parseString = (newValue: any): any => {
    try {
        let value;
        if (typeof newValue === 'object') {
            value = JSON.stringify(newValue).replace(/"/g, '\'');
        }
        else {
            value = newValue;
        }
        // console.log('[TRAZA] object parsed! ', value)
        return value;
    } catch (error) {
        return newValue
    }
}
export const capitalice = (str: any) => {
    str = str?.toLowerCase();
    const capitalized = str?.charAt(0).toUpperCase() + str?.slice(1);

    return capitalized;
}
export const checkUnder16 = (user: any) => {
    if (user.under16 === null) {
        return CHECKAGE.askRequired;
    }

    else if (user.under16 === false) {
        if (user.birthDate !== null && !!user.birthDate) {
            const date = new Date(user.birthDate);
            const current = new Date();
            if (current.getFullYear() - date.getFullYear() < 16) {
                return CHECKAGE.isUnderAge;
            }
            //Es menor de 16 pero no tenemos la edad
        } else if (user.birthDate === null) {
            return CHECKAGE.mandatoryAgeNeededNoOver16;
        }
        else {
            return CHECKAGE.mandatoryAgeNeeded;
        }
    }
    else if (user.under16 === true) {
        return CHECKAGE.isUnderAge;
    }
}
export enum CHECKAGE {
    askRequired = 'askRequired',
    isUnderAge = 'isUnderAge',
    mandatoryAgeNeeded = 'mandatoryAgeNeeded',
    mandatoryAgeNeededNoOver16 = 'mandatoryAgeNeededNoOver16'
}

export function isEmptyObject(obj: object = {}) {
    return obj
        && Object.keys(obj).length === 0
        && Object.getPrototypeOf(obj) === Object.prototype
}

export function emptyArray(data: any) {
    return Array.isArray(data) && data.length === 0;
}

export function mappingScreenNameAnalytics(url: string) {
    // let result=url.substring(5,url.length);
    let path = url.split('/'); // ["app", "my-trips"]
    let result = path[path.length - 1]; // Cojo el ultimo item del array.
    switch (result) {
        case 'my-trips':
            result = "trips";
            break;

        case 'my-profile':
            result = "profile";
            break;

        // default:
        //     result;
        //     break;
    }
    return result;
}

export function getTransportIcon(step: any, text: any): UiTagData {
    try {
        // border generico (gris) #dadce0 
        const data = step?.Product?.[0]?.icon;
        const { backgroundColor, foregroundColor } = data;
        const tag = {
            text,
            color: foregroundColor.hex,
            backgroundcolor: backgroundColor.hex,
            bordercolor: backgroundColor.hex === '#ffffff' ? foregroundColor.hex : null
        }
        // console.log('getTransportIcon:', tag);
        return tag;
    } catch (error) {
        return { text, color: '', backgroundcolor: '', bordercolor: '' }
    }
}
export interface TransportSwitch {
    icon: string;
    transportTypeString: string;
    text: string;
    size: string;
    background: string;
}

export interface UiTagData {
    text: string;
    color: string;
    backgroundcolor: string;
    bordercolor?: string;
    icon?: string;
    origin?:string
    hasIcon?: string;
}

